import * as routes from 'Routes/routesConstants'

export const path = {
  jobDescription: `${routes.myJobs}${routes.applied}${routes.jobDescription}`,
  appliedBy: `${routes.myJobs}${routes.applied}${routes.jobDescription}${routes.appliedServiceProviders}`,
  appliedByProfile: `${routes.myJobs}${routes.applied}${routes.jobDescription}${routes.appliedServiceProviders}${routes.freelancerProfile}`
}
